/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable react/no-will-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Tabs from '../tabs/index';
import Contenido from './contenido';
import PaquetesClient from '../../api/paquetes';
import Common from '../../commons/commons';
import Buscador from '../buscadores/buscador-vertical/buscador';
import Filtros from '../filtros/index';
import { getNavigation } from '../../redux/actions/application-actions';
import {
  setPaqueteOriginal,
  setSearchDestinationAndOrigin,
} from '../../redux/actions/packages-actions';
import ProgressBar from '../../commons/progress-bar';
import BreadCrumb from './breadcrumb-lista';
import './paquete-lista.css';
import { getLocationInfo } from '../../api/http-client';

class ListaPaquetes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtroOperador: false,
      filtrados: [],
      cantidadPaquetes: 0,
      cantidadPasajeros: 0,
      preloader: true,
      progressNow: 0,
      showProgress: true,
      progressError: null,
      distribucion: '2',
    };

    this.getPaquetes = this.getPaquetes.bind(this);
    this.calcularPasajeros = this.calcularPasajeros.bind(this);
    this.getPaquetePaginador = this.getPaquetePaginador.bind(this);
    this.BorrarProgress = this.BorrarProgress.bind(this);
  }

  componentDidMount() {
    this.calcularPasajeros(() => {
      this.props.getNavigation();
      this.getPaquetes();
    });
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate(nextProps, nextState) {
    if (nextProps !== this.props) {
      const { filtrados } = nextProps.packages;
      if (filtrados !== undefined && filtrados !== this.state['filtrados']) {
        this.setState({ filtrados });
      }
    }
  }

  calcularPasajeros(callback) {
    const urlProps = window.location.pathname.split('/');
    const distributionCode = urlProps[4] || '2';
    const distribucion = Common.obtenerDistribucion(distributionCode);
    const cantPasajeros = Common.obtenerCantidadPasajeros(distribucion);
    this.setState(
      {
        cantidadPasajeros: cantPasajeros,
        distribucion: distributionCode,
      },
      () => {
        callback();
      },
    );
  }

  getPaquetePaginador() {
    this.setState({ preloader: true });
    this.getPaquetes();
  }

  getPaquetes() {
    const _this = this;
    const { token } = this.props.application;
    const { distribucion } = this.state;
    const { pathname } = window.location;
    const pathnameParts = (
      pathname.slice(0, 1) === '/' ? pathname.slice(1, [pathname.length - 1]) : pathname
    ).split('/');
    const data = {
      Categoria: pathnameParts[2],
      Distribucion: distribucion,
      Pagina: 1,
      paquetesPorPagina: process.env.RAZZLE_PAQUETES_POR_PAGINA,
    };
    let uniqueExecution = true;

    PaquetesClient.obtenerPaquetesCategorias(
      data,
      token,
      (res) => {
        if (uniqueExecution) {
          _this.props.setSearchDestinationAndOrigin(res.data.ciudades);
          uniqueExecution = false;
        }
        _this.props.setPaqueteOriginal(res.data.paquetes);
        _this.setState({
          cantidadPaquetes: res.data.paginado.totalRegistros,
          progressNow: _this.state.progressNow + res.data.paquetes.length,
          preloader: false,
        });
      },
      () => {
        if (parseInt(_this.state.cantidadPaquetes) === 0) {
          _this.setState({
            preloader: false,
            filtrados: [],
          });
        } else {
          _this.setState({
            progressError:
              'Por un Error no pudimos traer todos los paquetes de este destino, podemos intentarlo nuevamente si recargas la página',
            progressNow: _this.state.cantidadPaquetes,
          });
        }
      },
    );
  }

  ArmarUrl = () => {
    const urlString = window.location.href;
    return new URL(urlString);
  };

  BorrarProgress = () => {
    this.setState({ showProgress: false });
  };

  CalcularProgress = (ahora, total) => {
    return (ahora * 80) / total + 20;
  };

  ObtenerNombreDeLugar = (lugar) => {
    const item = sessionStorage.getItem(lugar);
    if (item != null) {
      return JSON.parse(item).name;
    }
    return '';
  };

  MostrarFiltros = () => {
    return this.state.cantidadPaquetes > 0;
  };

  createSeoElements() {
    try {
      const { pathname, href } = getLocationInfo();
      const { nombre } = this.props.application;
      const [, , , , , categoryTitle] = pathname.split('/');
      const scapedTitle = categoryTitle.replace(/-/g, ' ').replace(/\s/g, ' ');
      const formatScapeTitle = scapedTitle.charAt(0).toUpperCase() + scapedTitle.slice(1);

      const title =
        formatScapeTitle && formatScapeTitle !== '' && formatScapeTitle.length > 4
          ? `${formatScapeTitle} | ${nombre}`
          : nombre;
      const description =
        formatScapeTitle && formatScapeTitle !== '' && formatScapeTitle.length > 4
          ? `${formatScapeTitle}, aprovecha las mejores opciones para tus vacaciones con ${nombre}`
          : '';
      const h1 =
        formatScapeTitle && formatScapeTitle !== '' && formatScapeTitle.length > 4
          ? `${formatScapeTitle}`
          : '';
      const paragraphTitle = `${formatScapeTitle}, aprovecha las mejores opciones para tus vacaciones con ${nombre}`;
      const paragraph = `${formatScapeTitle},  aprovecha nuestras ofertas y paquetes especiales, contactá a nuestros expertos y encontrá la mejor atención. Somos la mejor opción para tus vacaciones, en ${nombre} tenemos las mejores ofertas de viajes, paquetes, vuelos y hoteles para vos!`;

      return {
        metaTags: (
          <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={href} />
          </Helmet>
        ),
        h1: scapedTitle && (
          <>
            <h1 className="s-h1">{h1}</h1>
          </>
        ),
        paragraph: (
          <div className="container">
            <div className="paragraph-seo-container">
              <h2 className="color-dinamico">{paragraphTitle}</h2>
              <p>{paragraph}</p>
            </div>
          </div>
        ),
      };
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      return {
        metaTags: '',
        h1: '',
        paragraph: '',
      };
    }
  }

  render() {
    const { filtrados, filtroOperador, progressNow, cantidadPaquetes, showProgress } = this.state;
    const { metaTags, h1, paragraph } = this.createSeoElements();
    let progressLabel = '';
    let origenDisplay = '';

    if (filtrados.length !== 0 && filtrados[0].salidas) {
      origenDisplay =
        filtrados[0].salidas[0].origen === filtrados[0].salidas[0].origenIata
          ? this.ObtenerNombreDeLugar(filtrados[0].salidas[0].origenIata)
          : filtrados[0].salidas[0].origen;

      progressLabel =
        progressNow < cantidadPaquetes
          ? `Estamos Buscando! Paquetes: ${progressNow}`
          : `${t('packages_list.found', {
              cp: cantidadPaquetes,
              destino: filtrados[0].salidas[0].destino,
              origen: origenDisplay,
            })}`;
    }

    if (this.state.progressError) {
      progressLabel = this.state.progressError;
    }

    const progress = this.CalcularProgress(progressNow, cantidadPaquetes);

    if (
      cantidadPaquetes !== 0 &&
      progressNow === cantidadPaquetes &&
      showProgress &&
      !this.state.progressError
    ) {
      _.delay(this.BorrarProgress, 5000);
    }

    let mobile = false;

    if (typeof window !== 'undefined') {
      mobile = window.innerWidth <= 768;
    }

    return (
      <div>
        {metaTags}
        <Tabs />
        <div className="listado-paquetes">
          <div className="listado">
            <BreadCrumb origin="" destination="" searchingMonth="" />
            <div className="container">
              {h1}
              <div className="row">
                <div className="col-lg-3 col-md-3">
                  <div className="btn-collapse-container hidden-lg hidden-md">
                    <a
                      style={{ padding: '6px 0' }}
                      className="text-center hidden-lg hidden-md"
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion-filtro-busqueda"
                      href="#collapseBuscador"
                      aria-expanded="false"
                      aria-controls="collapseBuscador"
                      id="collapse-buscador"
                    >
                      <i className="fa fa fa-search" /> Editar busqueda
                    </a>

                    <a
                      style={{ padding: '6px 0' }}
                      className="text-center hidden-lg hidden-md color-dinamico-fondo"
                      role="button"
                      data-toggle="collapse"
                      data-parent="#accordion-filtro-busqueda"
                      href="#collapseFiltros"
                      aria-expanded="false"
                      aria-controls="collapseFiltros"
                      id="collapse-filtros"
                    >
                      <i className="fa fa fa-sliders" /> Filtros
                    </a>
                  </div>
                  {typeof window !== 'undefined' && (
                    <div
                      className="panel-group"
                      id="accordion-filtro-busqueda"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div className="panel panel-default">
                        <div
                          id="collapseBuscador"
                          className="panel-collapse collapse buscador"
                          role="tabpanel"
                          aria-labelledby="headingThree"
                        >
                          {mobile && <Buscador idUnico="mobile-searcher" />}
                          <div
                            className="panel-heading hidden-lg hidden-md"
                            role="tab"
                            id="headingThree"
                          >
                            <h4
                              className="panel-title text-center close-collapse"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion-filtro-busqueda"
                              href="#collapseBuscador"
                              aria-expanded="false"
                              aria-controls="collapseBuscador"
                            >
                              <a className="collapsed">
                                <i className="pull-right fa fa-chevron-up" />
                              </a>
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div className="panel panel-default fitro-buscador">
                        <div
                          id="collapseFiltros"
                          className={`panel-collapse collapse ${mobile ? '' : 'in'}`}
                          role="tabpanel"
                          aria-labelledby="headingThree"
                        >
                          <Filtros
                            mostrarOperador={filtroOperador}
                            cantidadPasajeros={this.state.cantidadPasajeros}
                            show={cantidadPaquetes !== 0}
                          />
                          <div
                            className="panel-heading hidden-lg hidden-md"
                            role="tab"
                            id="headingThree"
                          >
                            <h4
                              className="panel-title text-center close-collapse"
                              role="button"
                              data-toggle="collapse"
                              data-parent="#accordion-filtro-busqueda"
                              href="#collapseFiltros"
                              aria-expanded="false"
                              aria-controls="collapseFiltros"
                            >
                              <a className="collapsed">
                                <i className="pull-right fa fa-chevron-up" />
                              </a>
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className={this.state.preloader ? 'col-lg-6 col-md-6 ' : 'col-lg-9 col-md-9'}>
                  {showProgress && filtrados.length !== 0 ? (
                    <div className="progressBar">
                      <ProgressBar label={progressLabel} progress={progress} />
                    </div>
                  ) : null}

                  {filtrados !== undefined && (
                    <Contenido
                      buscarPaquetes={this.getPaquetePaginador}
                      distribucion={this.state.distribucion}
                      preloader={this.state.preloader}
                      paquetes={filtrados}
                      cantidadPaquetes={this.state.cantidadPaquetes}
                      cantidadPasajeros={this.state.cantidadPasajeros}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {paragraph}
        <hr style={{ borderColor: '#d2d2d2', margin: '25px 0 0 0' }} />
      </div>
    );
  }
}

const mapStateToProps = function (store) {
  return {
    actualModule: store.applicationState.navigation.actualModule,
    packages: store.packages,
    application: store.applicationState,
  };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { getNavigation, setPaqueteOriginal, setSearchDestinationAndOrigin },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ListaPaquetes);
